import React from 'react'
import { shallow } from 'enzyme'

import TopicTitleInput from '../../features/TextEditor/TopicTitleInput'

describe('TopicTitleInput', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      predefined: true,
    },
      wrapper = shallow(<TopicTitleInput {...props} />)
    instance = wrapper.instance()
  })
  describe('#render', () => {
    describe('when predefined is true', () => {
      it('should set the readOnly props on input to true', () => {
        const titleInput = wrapper.find('TopicTitleInput__Input').at(0)
        expect(titleInput.props().readOnly).toBeTruthy()
      })
    })
    describe('when predefined is false', () => {
      it('should set the readOnly props on input to false', () => {
        props.predefined = false
        wrapper = shallow(<TopicTitleInput {...props} />)
        instance = wrapper.instance()
        const titleInput = wrapper.find('TopicTitleInput__Input').at(0)
        expect(titleInput.props().readOnly).toBeFalsy()
      })
    })
  })
})